import {
  Prismic,
  PrismicLink,
  fallbackText,
  getDataFromLink,
} from '@landsbankinn/prismic';
import { Button } from '@landsbankinn/ui';
import { hyphenate } from '@landsbankinn/utils';
import React from 'react';
import type { TitleColor } from '../components/hero/Hero';
import {
  FontSize,
  Hero,
  ImageAlignment,
  TitlePosition,
} from '../components/hero/Hero';

interface IProps {
  alignment: ImageAlignment;
  title: Prismic.RichText;
  text_center: boolean;
  text_bottom: boolean;
  backdrop_enabled: boolean;
  smaller_font: boolean;
  image: Prismic.Image;
  button_text: Prismic.RichText;
  link: Prismic.Link;
  button_text_2?: Prismic.RichText;
  link_2?: Prismic.Link;
  shade_opacity?: number;
  font_size: number;
  title_width: number;
  title_position: string;
  title_color?: TitleColor;
}

const AlignmentMap = {
  Fullscreen: ImageAlignment.FULLSCREEN,
  Center: ImageAlignment.CENTER,
  Right: ImageAlignment.RIGHT,
  Left: ImageAlignment.LEFT,
};

export const FrontPageHeroContainer = ({
  alignment,
  title,
  text_center,
  text_bottom,
  smaller_font,
  image,
  button_text,
  link,
  shade_opacity,
  link_2,
  button_text_2,
  font_size,
  title_width,
  title_position,
  title_color,
}: IProps) => {
  const buttonLinkdata = getDataFromLink(link);
  const buttonTitle = fallbackText(
    button_text,
    buttonLinkdata.title ?? undefined,
  );

  const buttonLinkdata_2 = getDataFromLink(link);
  const buttonTitle_2 = fallbackText(
    button_text_2 as any,
    buttonLinkdata_2.title ?? undefined,
  );

  const action = link ? (
    <PrismicLink value={link} title={buttonTitle ?? undefined}>
      <Button
        as="a"
        title={buttonTitle ?? undefined}
        icon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="10"
            fill="none"
            viewBox="0 0 29 10"
          >
            <path
              fill="#fff"
              d="M19.7971.115967l9.1304 4.565213-9.1304 4.56522V5.18843H.521729V4.17394H19.7971V.115967z"
            />
          </svg>
        }
        id={link_2 ? 'secondary_cta_button' : 'main_cta_button'}
      />
    </PrismicLink>
  ) : null;
  const secondAction = link_2 ? (
    <PrismicLink value={link_2} title={buttonTitle_2 ?? undefined}>
      <Button as="a" title={buttonTitle_2 ?? undefined} id="main_cta_button" />
    </PrismicLink>
  ) : null;

  return (
    <Hero
      title={hyphenate(Prismic.text(title))}
      image={image}
      alignment={(AlignmentMap as any)[alignment]}
      shadeOpacity={shade_opacity}
      actions={
        secondAction !== null ? (
          <>
            {action}
            {secondAction}
          </>
        ) : (
          action
        )
      }
      center={text_center}
      smallerFont={smaller_font}
      bottom={text_bottom}
      fontSize={(FontSize as any)[font_size]}
      titleWidth={title_width}
      titlePosition={(TitlePosition as any)[title_position]}
      titleColor={title_color}
    />
  );
};
